import Pagination from "@mui/material/Pagination";

import Tabs from "ui/base/Tabs";
import Page from "ui/Page";
import Table from "ui/Table";

import { usePartners } from "../fabric";


export default function Partners() {
	const partners = usePartners();
	const tab = partners.filters.status || "other";

	return (
		<Page>
			<Page.Header title="Partners" />
			<Page.Body>
				<Tabs value={tab} onChange={(_, status: "other" | "active") => partners.setFilters({ status })} variant="fullWidth" textColor="secondary" indicatorColor="secondary">
					<Tabs.Tab label="Other" value="other" />
					<Tabs.Tab label="Active" value="active" />
				</Tabs>
				<Table columns={partners.columns} data={partners.query.data?.values} icon="list-todo" />
				{partners.query.data?.pagination?.Pages ? <Pagination siblingCount={0} page={partners.query.data?.pagination?.Page || 1} count={partners.query.data?.pagination?.Pages} color="secondary" onChange={(_, page) => partners.setFilters({ page })} /> : null}
			</Page.Body>
		</Page>
	);
}